
import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { Logo } from "../core/path/images";
import FeatherIcon from "feather-icons-react";
import {  useNavigate } from "react-router-dom";
import { toastrError, toastrSuccess } from "../utils/alertify";
import { ErrorsAndMessages, ErrorsAndMessagesr } from "../utils/constants";
import { forgetPassword } from "../core/axios/endpoints";



const ForgetPasswordPage = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const validationSchema = Yup.object().shape({
    email: Yup.string().required(ErrorsAndMessages.emailRequired).email(ErrorsAndMessages.emailInvalid),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });



  const submitForm = (data) => {
    setIsLoading(true);
    forgetPassword(data).then((user) => {
      toastrSuccess(data.message || ErrorsAndMessages.emailSent);
      setIsSuccess(true);
      setSuccessMessage(data.message || ErrorsAndMessages.emailSent);
    }).catch((err) => {
      toastrError(err.response?.data?.error || ErrorsAndMessages.emailInvalid);
    }).finally(() => {
      setIsLoading(false);
    })
  }


  return (
    <>
      <div className="main-wrapper">
        <div className="forget-password-page">
          <div className="logo">
            <img src={Logo} alt="" />
          </div>

          <div className="sign-in-form">
            <h1>Wachtwoord vergeten</h1>
            <p className="mt-2">
            Vul uw e-mailadres in, wij sturen u een link om uw wachtwoord opnieuw in te stellen.

            </p>
            <form  onSubmit={handleSubmit((data) => submitForm(data))}>
              <div className="mt-4">
                <label className="block" htmlFor="email">
                  Email
                </label>
                <input
                id="email"
                name="email"
                type="text"
                placeholder="Voer uw e-mailadres in"
                autoComplete="new-password"
                  className={`${errors.email ? "is-invalid" : ""} appearance-none w-full`}
                  {...register("email")}
                />
                <div className="invalid-feedback min-h-4">{errors.email?.message || " "}</div>
              </div>


             <div className="mt-6">
             <button disabled={isSuccess} className="inline-flex h-10 w-full items-center justify-center rounded bg-brand text-sm font-medium text-white hover:bg-brand-hover disabled:cursor-not-allowed disabled:opacity-50">
                    {
                      isLoading ?
                      <span className='flex items-center gap-1.5'>
                      <FeatherIcon icon="loader" className={`w-4 h-4 animate-spin`} />
                      Valideren...
                      </span>
                      : "Verstuur"
                    }
             </button>

             { isSuccess && <div className="mt-4 flex items-start gap-2 rounded bg-[#DCFFF1] px-3 py-2 text-sm text-[#1F845A]">
             <FeatherIcon icon="check-circle" size={16} className="mt-0.5 shrink-0" />
             <span>Er is een resetlink naar uw e-mailadres verzonden. Controleer uw mailbox om uw wachtwoord opnieuw in te stellen.</span>
             </div>}
             </div>
            </form>
            <div className="sign-up-link">

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPasswordPage;
